import React, { useState } from "react";
import { useEffect } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import _ from "lodash";
import ApiAmusementService from "../../../../core/api/api.amusementService";

const ChangesHistoryModal = ({ showModalChangesHistory, setShowModalChangesHistory, selectedServiceId }) => {
  const [changesHistory, setChangesHistory] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      if (selectedServiceId == 0) return;
      try {
        const response = await ApiAmusementService.getAllHistory({ id: selectedServiceId });
        setChangesHistory(response);
        setLoadingData(false);
      } catch (error) {
        setLoadingData(false);
      }
    };
    fetchData();
  }, [selectedServiceId]);

  const handleCloseShowModal = () => {
    setShowModalChangesHistory(false);
  };

  return (
    <Modal show={showModalChangesHistory} onHide={handleCloseShowModal}>
      <Modal.Header closeButton>
        <Modal.Title> تاریخچه تغییرات فرم رزرو</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedServiceId == 0 && <div>ابتدا تفریح مورد نظر را انتخاب کنید.</div>}
        {selectedServiceId != 0 && (loadingData ? (
          <div> در حال دریافت اطلاعات </div>
        ) : (
          <>
            {changesHistory.length === 0 && <div>تاریخچه ای برای این تفریح ثبت نشده است.</div>}
            {changesHistory.length > 0 && (
              <Table striped hover responsive="md" bordered={false} borderless={false}>
                <thead className="border">
                  <tr className="border">
                    <th className="bg-light-primary ">
                      <small className="text-center text-muted"></small>
                    </th>
                    <th className="bg-light-primary ">
                      <small className="text-center text-muted">تاریخ تغییر</small>{" "}
                    </th>
                    <th className="bg-light-primary ">
                      <small className="text-center text-muted">ساعت تغییر</small>
                    </th>
                    <th className="bg-light-primary ">
                      <small className="text-center text-muted">توسط</small>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {changesHistory.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <small>{changesHistory.length - index}</small>
                      </td>
                      <td>
                        <small>{item.date.split(" ")[0]}</small>
                      </td>
                      <td>
                        <small>{item.date.split(" ")[1]}</small>{" "}
                      </td>
                      <td>
                        <small>{item.userFullName}</small>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseShowModal}>
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangesHistoryModal;
